module.exports = __webpack_public_path__ + "static/img/icon_card@2x.e0251efb.png";